import jQuery from 'jquery';
import CookieNotice from './App/CookieNotice';
import ListHandler from './App/ListHandler';
import Carousel from './App/Carousel';
import { MenuModule } from './App/MenuModule';
import { ObjectFitModule } from './App/ObjectFitModule';

window.$ = jQuery;

document.addEventListener("DOMContentLoaded", () => {
	let menuModule = new MenuModule();
	let objectFitModule = new ObjectFitModule();
	let cookieNoticHandler = new CookieNotice();
	let listHandler = new ListHandler();

	$('[data-carousel]').each((index, element) => {
		let carousel = new Carousel(element);
		carousel.init();
	})
}); 



// WEBPACK FOOTER //
// ./assets/scripts/front/index.js